<template>
  <card style="height: 33%;">
    <div
      v-if="metes.length === 1"
      class="device-picker"
      style="right: auto;left: 20px;top: 12px;"
    >
      {{ metes[0].name }}
    </div>

    <el-select
      v-else
      class="device-picker left"
      popper-class="device-picker__popper"
      size="mini"
      style="right: auto;left: 20px;top: 12px;"
      :value="deviceId"
      @input="deviceChange"
    >
      <el-option
        v-for="item in metes"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>

    <div class="" style="margin-top: 52px;height: 100%;">
      <div
        class=""
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
        style="width: 100%;height: 100%;"
      >
        <echart
          v-if="!loadingCols && !loading"
          chartId="meteorology"
          :options="options"
          :height="height - 52"
          :notMerge="true"
        ></echart>
      </div>
    </div>
  </card>
</template>

<script>
import mixin from '../mixin'
import Card from '../card'
import Echart from '@/components/Chart'
import { list, cols } from '@/service/meteorology'
import { subtract, add } from '@/utlis/date'
import _ from 'lodash'
import sleep from '@/utlis/sleep'

export default {
  mixins: [mixin],
  components: { Card, Echart },
  data() {
    return {
      loadingCols: true, // 初始化列数据
      loading: true,
      deviceId: null,
      cols: [],
      data: {
        dataset: { source: [] },
        series: []
      }
    }
  },
  computed: {
    options() {
      if (!(this.data.series.length === this.keys.length)) return {}
      return {
        legend: {
          type: 'scroll',
          left: '30%',
          right: '6%',
          bottom: 12,
          pageButtonGap: 20,
          textStyle: { color: '#9aa8d4' },
          pageTextStyle: { color: '#dcdfe6', fontSize: 14 }
        },
        tooltip: {
          transitionDuration: 0
        },
        grid: [
          {
            top: 12,
            left: 52,
            right: '56%',
            bottom: 72
          },
          {
            top: 12,
            left: '54%',
            right: 40,
            bottom: 72
          }
        ],
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            gridIndex: 0
          },
          {
            type: 'category',
            gridIndex: 1
          }
        ],
        yAxis: _.uniqBy(this.keys, o => o.y).map((k, index) => ({
          type: 'value',
          gridIndex: index <= 1 ? 0 : 1,
          show: !k.renderItem,
          name: k.name,
          splitLine: { show: false }
        })),
        ...this.data
      }
    },
    keys() {
      const keys = [
        { name: '空气温度', type: 'line', x: 0, y: 0 },
        { name: '空气湿度', type: 'line', x: 0, y: 1 },
        { name: '降雨量', type: 'bar', x: 1, y: 2 },
        { name: '风速', type: 'line', x: 1, y: 3 }
      ]

      if (!this.cols.find(c => c.name === '空气温度')) {
        let soilT = this.cols.filter(c => c.name.includes('土壤温度'))
        let soilH = this.cols.filter(c => c.name.includes('土壤湿度'))
        let other = this.cols.filter(c => c.name.includes('离子'))

        if (!other.length) {
          other = this.cols.filter(c => c.name === '盐分')
        }

        let s1 = soilT.map(s => ({
          type: 'line',
          x: 0,
          y: 0,
          key: s.key,
          name: s.name
        }))
        let s2 = soilH.map(s => ({
          type: 'line',
          x: 0,
          y: 1,
          key: s.key,
          name: s.name
        }))
        let s3 = other.map(o => ({
          type: 'line',
          x: 1,
          y: 2,
          key: o.key,
          name: o.name
        }))
        return s1.concat(s2, s3)
      }
      return keys
        .map(k => {
          const col = this.cols.find(c => c.name === k.name) || {}
          return { ...col, ...k }
        })
        .filter(o => o.key)
    }
  },
  async mounted() {
    if (this.metes && this.metes[0]) {
      this.deviceId = this.metes[0].id
      await this.getCols()
      this.loading = true
      this.data = await this.getData()
      this.loading = false
    }
  },
  methods: {
    async getCols() {
      this.loadingCols = true
      const { data } = await cols(this.deviceId)
      this.cols = data
      this.loadingCols = false
    },
    async getData() {
      this.loading = true
      const [{ data }] = await Promise.all([
        list({
          companyId: this.companyId,
          deviceId: this.deviceId,
          begin: subtract(undefined, 1, 'days', 'YYYY-MM-DD 00:00:00'),
          end: add(undefined, 1, 'days', 'YYYY-MM-DD 00:00:00'),
          type: 'day'
        }),
        sleep(1)
      ])

      this.loading = false

      return {
        dataset: {
          dimensions: ['date'].concat(this.keys.map(c => c.key)),
          source: data
        },
        series: this.keys.map(k => {
          return {
            type: k.type || 'line',
            barWidth: '40%',
            name: k.name,
            renderItem: k.item || null,
            xAxisIndex: k.x,
            yAxisIndex: k.y,
            encode: k.encode || null
          }
        })
      }
    },
    async deviceChange(id) {
      this.deviceId = id
      await this.getCols()
      this.loading = true
      this.data = await this.getData()
      this.loading = false
    }
  }
}
</script>

<style lang="css" scoped></style>
